import { configureStore } from "@reduxjs/toolkit";
import { api } from "../api/redux.js";
import accountsReducer from "../features/accounts/accountsSlice.js";
import activitiesReducer from "../features/activities/activitiesSlice.js";
import assessmentsReducer from "../features/assessments/assessmentsSlice.js";
import billingReducer from "../features/billing/billingSlice.js";
import companyReducer from "../features/company/companySlice.js";
import contactsReducer from "../features/contacts/contactsSlice.js";
import { editorProposalsReducer } from "../features/copilot/editorProposalsSlice.js";
import customFieldDefinitionsReducer from "../features/customFieldDefinitions/customFieldDefinitionsSlice.js";
import featureFlagsReducer from "../features/featureFlags/featureFlagsSlice.js";
import insightsReducer from "../features/insights/insightsSlice.js";
import integrationsReducer from "../features/integrations/integrationsSlice.js";
import interviewsReducer from "../features/interviews/interviewsSlice.js";
import keywordTrackersReducer from "../features/keywordTrackers/keywordTrackersSlice.js";
import authorizationReducer from "../features/miscellaneous/authorizationSlice.js";
import notificationsReducer from "../features/notificationsOverlay/notificationsSlice.js";
import phoneNumbersReducer from "../features/phoneNumbers/phoneNumbersSlice.js";
import projectsReducer from "../features/projects/projectsSlice.js";
import teammateReducer from "../features/teammate/teammateSlice.js";
import teammatesReducer from "../features/teammates/teammatesSlice.js";
import transcriptFragmentsReducer from "../features/transcriptFragments/transcriptFragmentsSlice.js";

export function createStore() {
  return configureStore({
    reducer: {
      teammate: teammateReducer,
      company: companyReducer,
      teammates: teammatesReducer,
      projects: projectsReducer,
      notifications: notificationsReducer,
      interviews: interviewsReducer,
      contacts: contactsReducer,
      accounts: accountsReducer,
      transcriptFragments: transcriptFragmentsReducer,
      insights: insightsReducer,
      activities: activitiesReducer,
      keywordTrackers: keywordTrackersReducer,
      integrations: integrationsReducer,
      customFieldDefinitions: customFieldDefinitionsReducer,
      featureFlags: featureFlagsReducer,
      billing: billingReducer,
      phoneNumbers: phoneNumbersReducer,
      assessments: assessmentsReducer,
      authorization: authorizationReducer,
      editorProposals: editorProposalsReducer,
      [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // We stick immutable but non-serializable luxon DateTime objects in the state for performance reasons
        serializableCheck: {
          ignoredActions: ["api/executeQuery/fulfilled"],
          ignoredPaths: [api.reducerPath],
        },
      }).concat(api.middleware),
  });
}

export type AppStore = ReturnType<typeof createStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
